import { api, formHeaders, parseBoolean } from "@";
import type { CarouselFormValues } from "../types";

// Fetches a page of carousel slides.
// Response: { data: CarouselItem[], totalItems, currentPage, pageSize, totalPages, ... }
export const getCarousels = (page = 1, perSize: number | null = null) =>
  api.get(`/api/AdminHomeSlider`, {
    params: { Page: page, PageSize: perSize },
  });

// Saves a carousel slide (creates or updates based on the presence of an id)
export const saveCarousel = (data: CarouselFormValues) => {
  const payload = {
    Title: data.title,
    Image: data.image,
    order: data.order || 0,
    isActive: parseBoolean(data.isActive) || false,
  };

  if (data.id) {
    return api.put(`/api/AdminHomeSlider/${data.id}`, payload, formHeaders);
  }
  return api.post(`/api/AdminHomeSlider`, payload, formHeaders);
};
